module.exports = __webpack_public_path__ + "public/adminIcons/total-user.png?b05242be";